export default {
  categories: [],
  category: {}
}